import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import {viewAllocatedRequestService } from './viewallocaterequest.service';
import { global } from '../../shared/global';
import { FeesIncrease } from '../Models/updatependingrequest.model'
declare var $: any;

@Component({
  selector: 'app-viewallocaterequest',
  templateUrl: './viewallocaterequest.component.html',
  styleUrls: ['./viewallocaterequest.component.css']
})
export class ViewallocaterequestComponent implements OnInit {
  searchtext;
  isDesc: boolean;
  column: string;
  FeesIncreaseList: Array<any>;
  FeesIncreaseDetail: Array<any>;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  HashCode:any;
  data: FeesIncrease;
  schoolname:any;
  totalAmt:any;
  SchoolName: any;
  Medium: any;
  AcademicYear: any;
  Standard: any;
  CourseYear: any;

  constructor(private service: viewAllocatedRequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.HashCode = this.rout.snapshot.paramMap.get('ID');
      this.schoolname = "- ("+ localStorage.getItem("SchoolName") +")";
      if (this.HashCode.trim() == "") {
        this.router.navigate(['/registrationlist']);
        return;
      }
    } else {
      this.router.navigate(['/registrationlist']);
      return;
    }
    this.getFeesIncreaseList();
    this.data = new FeesIncrease();
  }

  getFeesIncreaseList() {
    this.spinner.show();
    const data = {
      HashCode: this.HashCode
    };
    this.service.getFeesIncreaseList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.FeesIncreaseList = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.show();
          this.FeesIncreaseList = this.responseData.AllocatedFeesList;
          this.spinner.hide();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  viewFeesDetail(i){
    $('#detailModal').modal('show');
    this.FeesIncreaseDetail =  this.FeesIncreaseList[i]["AllocatedFeesDetail"];
    this.SchoolName =  this.FeesIncreaseList[i]["SchoolName"];
    this.Medium =  this.FeesIncreaseList[i]["SchoolName"];
    this.AcademicYear =  this.FeesIncreaseList[i]["AcademicYear"];
    this.Standard =  this.FeesIncreaseList[i]["Standard"];
    this.CourseYear=  this.FeesIncreaseList[i]["CourseYear"];
    this.totalAmt = this.FeesIncreaseList[i]["TotalAmount"];
  }

  // editRequest(HashCode){
  //   this.spinner.show();
  //   const data = {
  //     HashCode: HashCode
  //   };
  //   this.service.fillAllocatedFeesIncreaseDetail(data)
  //     .subscribe(data => {
  //       this.responseData = data;
  //       this.spinner.hide();
  //       if (this.responseData.tokenStatus == false) {
  //         localStorage.clear();
  //         this.toastr.error(this.responseData.message);
  //         this.router.navigate(['/aciadmin']);
  //         return
  //       }
  //       if (this.responseData.status == false) {
  //         this.toastr.error(this.responseData.message);
  //         return
  //       }
  //       else {
  //         this.spinner.show();
  //         this.FeesIncreaseDetail = this.responseData.AdminFeesIncreaseDetails;
  //         this.spinner.hide();
  //         $('#detailModal').modal('show');
  //       }
  //     }, (err: HttpErrorResponse) => {
  //       localStorage.clear();
  //       this.spinner.hide();
  //       this.toastr.error('Something Went Wrong');
  //       this.router.navigate(['/aciadmin']);
  //     });
  // }

  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.FeesIncreaseList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }

  closeForm() {
    $('#detailModal').modal('hide');
    this.getFeesIncreaseList();
  }
}
